export default {
  serviceCommand: "TOKENIZATION",
  language: "en"
};
